const getSpecificity = (path) => {
  return (path.match(/\//g) || []).length
}

export const showSkinnyBanner = (
  currentPath: string,
  pagesToShow: string[] | undefined,
  pagesToExclude: string[] | undefined
): number => {
  let highestSpecificity = -1

  if (pagesToExclude?.length) {
    for (const page of pagesToExclude) {
      if (
        new RegExp(String.raw`^${page.replaceAll("*", ".*")}$`).test(
          currentPath
        )
      ) {
        return -1
      }
    }
  }

  if (pagesToShow?.length) {
    for (const page of pagesToShow) {
      if (
        new RegExp(String.raw`^${page.replaceAll("*", ".*")}$`).test(
          currentPath
        )
      ) {
        const specificity = getSpecificity(page)
        if (specificity > highestSpecificity) {
          highestSpecificity = specificity
        }
      }
    }
  }

  return highestSpecificity
}
